import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import DriverModeInfoModal from "@/components/AccountParts/DriverModeInfoModal.vue";
import RoleAssignInfoModal from '@/components/AccountParts/RoleAssignInfoModal.vue';
import { computed } from 'vue'

type modalContentType = {
  email: string,
  password: string,
  name: string[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoModal',
  props: {
    modelValue: { type: Boolean },
    isDriverMode: { type: Boolean, default: false },
    accountId: {},
    modalContent: {},
    update: {},
    isLoading: { type: Boolean, default: false },
    roleAssignAuthority: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  }
})

return (_ctx: any,_cache: any) => {
  return (props.isDriverMode)
    ? (_openBlock(), _createBlock(DriverModeInfoModal, {
        key: 0,
        modelValue: modelValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
        accountId: props.accountId,
        email: props.modalContent.email,
        password: props.modalContent.password,
        name: props.modalContent.name,
        isLoading: props.isLoading,
        isDriverMode: props.isDriverMode,
        roleAssignAuthority: props.roleAssignAuthority,
        update: props.update
      }, null, 8, ["modelValue", "accountId", "email", "password", "name", "isLoading", "isDriverMode", "roleAssignAuthority", "update"]))
    : (_openBlock(), _createBlock(RoleAssignInfoModal, {
        key: 1,
        modelValue: modelValue.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue).value = $event)),
        roleAssignAuthority: props.roleAssignAuthority
      }, null, 8, ["modelValue", "roleAssignAuthority"]))
}
}

})